import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { BasicForm } from "@components/shared";
import { currencyValidation } from "@util/validation";
import { dollarsToPennies } from "@util/formatters";

export default function LootItemForm({
  id = null,
  name = "",
  description = "",
  retailValue = "",
  onSuccess = () => {},
  orgId,
  prizeId,
  locationId,
}) {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  function onSubmit(formData) {
    setLoading(true);

    const formatted = {
      ...formData,
      value_in_pennies: dollarsToPennies(
        !id && retailValue ? retailValue : formData.retail_value
      ),
    };

    if (id) return onUpdate(formatted);

    return onCreate(formatted);
  }

  function onCreate(formData) {
    const req = { ...formData };

    if (locationId) req.location_id = locationId;
    if (orgId) req.organization_id = orgId;
    // if (prizeId) req.prize_id = prizeId;
    if (prizeId) {
      req.prize_id = prizeId;
      // req.quantity = 100;
      req.quantity = parseInt(formData.quantity);
    }

    const url = prizeId ? `/add-loot-item-to-prize/` : `/loot-locker/`;

    axios
      .post(url, req)
      .then(() => setLoading(false))
      .then(() => toast.success(t("common:created") + "!"))
      .then(() => onSuccess())
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  function onUpdate(formData) {
    const req = {
      ...formData,
      id,
    };

    axios
      .put(`/loot-items/${id}/`, req)
      .then(() => setLoading(false))
      .then(() => toast.success(t("common:updated") + "!"))
      .then(() => onSuccess())
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  const fields = [
    {
      name: "name",
      label: t("common:name"),
      initialValue: name,
      required: true,
      schema: () =>
        Yup.string()
          .max(50, t("validation:too_long"))
          .required(t("validation:required")),
    },
    {
      name: "description",
      label: `${t("common:description")} (${t("validation:maximum_characters", {
        count: 255,
      })})`,
      initialValue: description,
      textarea: true,
      required: false,
      schema: () =>
        Yup.string().max(
          255,
          t("validation:maximum_characters", { count: 255 })
        ),
    },
    {
      name: "retail_value",
      label: `${t("common:estimated_retail_value")} (xx.xx)`,
      initialValue: retailValue,
      required: true,
      schema: () =>
        Yup.string()
          .matches(currencyValidation, t("validation:currency_amount_invalid"))
          .required(t("validation:required")),
    },
    {
      name: "quantity",
      label: t("common:quantity"),
      initialValue: "",
      required: true,
      schema: () =>
        Yup.string()
          .matches(/^[1-9]\d*$/, t("validation:must_be_greater_than_zero"))
          .required(t("validation:required")),
    },
  ]
    .filter((f) => (!id && !prizeId ? !["description"].includes(f.name) : true))
    .filter((f) => (!prizeId ? !["quantity"].includes(f.name) : true));

  return (
    <BasicForm
      loading={loading}
      onSubmit={onSubmit}
      fields={fields}
      buttonProps={{
        fullWidth: id ? false : true,
        size: prizeId ? "lg" : "sm",
      }}
    />
  );
}
